<mat-form-field class="w-full no-padding" appearance="outline">
  <mat-label>{{ label | translate }}</mat-label>
  <mat-select
    [multiple]="multiple"
    [disabled]="disabled"
    [disableOptionCentering]="true"
    (selectionChange)="onInput($event.value)"
    [placeholder]="placeholder"
    [value]="value"
    #singleSelect>
    <mat-option class="background-white">
      <ngx-mat-select-search
        [formControl]="selectedValueFilter"
        placeholderLabel="{{ 'buscar' | translate }}"
        noEntriesFoundLabel="{{
          'sin-resultados' | translate
        }}"></ngx-mat-select-search>
    </mat-option>
    @if (!selectAllDesactive) {
      <mat-option [value]="selectNoneValue">{{ selectNoneText |  translate }}</mat-option>
    }
    @for (item of filteredValues | async; track item) {
      <mat-option [value]="idName ? item[idName] : item">
        @if (displayValue) {
          {{ displayValue(item) }}
        }
        @if (!displayValue) {
          {{ valueName ? item[valueName]: item }}
        }
      </mat-option>
    }
  </mat-select>
</mat-form-field>
